import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 受邀项目路由
 */
export default {
  path: 'invitation',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '受邀项目',
    icon: 'icon-side_supplier_invitation',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 项目列表
    {
      path: 'list',
      name: 'InvitationLetter',
      component: '/supplier-views/invitation-letter/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目列表',
        cache: true,
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 招标采购邀请详情
    {
      path: 'purchase/orders/:orderId/invites/:inviteId',
      name: 'PurchaseLetter',
      component: '/supplier-views/invitation-letter/purchase-letter',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '招标采购邀请详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '邀请详情' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '邀请详情'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '邀请详情'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '邀请详情' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 询比邀请详情
    {
      path: 'inquiry/orders/:orderId/invites/:inviteId',
      name: 'InquiryLetter',
      component: '/supplier-views/invitation-letter/inquiry-letter',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '询比邀请详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '邀请详情' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '邀请详情'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '邀请详情'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '邀请详情' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 竞价邀请详情
    {
      path: 'compete/order/:orderId/invite/:inviteId',
      name: 'CompeteLetter',
      component: '/supplier-views/invitation-letter/compete-letter',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '竞价邀请详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '邀请详情' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '邀请详情'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '邀请详情'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '邀请详情' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 机场谈判邀请详情
    {
      path: 'negotiation/order/:orderId/invite/:inviteId',
      name: 'NegotiationLetter',
      component: '/supplier-views/invitation-letter/negotiation-letter',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '机场谈判邀请详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '邀请详情' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '邀请详情'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '邀请详情'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '邀请详情' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 医院谈判邀请详情
    {
      path: 'negotiation-v2/order/:orderId/invite/:inviteId',
      name: 'NegotiationV2Letter',
      component: '/supplier-views/invitation-letter/negotiation-v2-letter',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '医院谈判邀请详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '邀请详情' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '邀请详情'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '邀请详情'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '邀请详情' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 直接采购邀请详情
    {
      path: 'direct-purchase/orders/:orderId/invites/:inviteId',
      name: 'DirectPurchaseLetter',
      component: '/supplier-views/invitation-letter/direct-purchase-letter',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '直接采购邀请详情',
        hidden: true,
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 五菱招标详情
    {
      path: 'wuling/bid/orders/:orderId/invites/:inviteId',
      name: 'WlBidLetter',
      component: '/supplier-views/invitation-letter/wl-bid-letter',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '招标采购邀请详情',
        hidden: true,
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
